<template>
  <div class="app_menu_container">
    <PageTitle :title="title" backPath="Home" />
    <div class="app_menu_main">
      <PageSearchDataList
        ref="PageSearchDataListRef"
        @toDetail="toDetail"
        :searchData="searchData"
        @loadNextPageData="loadNextPageData"
        :cardOption="cardOption"
      />
    </div>
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageSearchDataList from '@/components/app/PageSearchDataList.vue'

export default {
  components: {
    PageTitle,
    PageSearchDataList
  },
  data() {
    return {
      title: '零星费用',
      searchData: [],
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10, // 每页10条
        align: 'right',
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 卡片配置
      cardOption: {
        path: 'Sporadic',
        title: '零星费用',
        mainPersonKey: 'users_name',
        mainDateKey: 'r_date',
        col: [
          {
            label: '公司',
            key: 'company',
            type: 'string'
          },
          {
            label: '粘贴单据(张)',
            key: 'document_count',
            type: 'string'
          },
          // {
          //   label: '报销人',
          //   key: 'users_name',
          //   type: 'string'
          // },
          // {
          //   label: '报销日期',
          //   key: 'r_date',
          //   type: 'date'
          // },
          {
            label: '金额',
            key: 'amout',
            type: 'money'
          },
          {
            label: '事由',
            key: 'subject_matter',
            type: 'string'
          }
        ]
      },
      menuArgs: ''
    }
  },
  mounted() {
    if (this.$route.query?.type && this.$route.query.type === 'todo') {
      this.menuArgs = 'phone'
    } else {
      this.menuArgs = ''
    }

    this.list()
  },
  methods: {
    // 获取数据
    async list() {
      const { data: res } = await this.$http.post('/finance/petty_expense_reimbursement_form/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: 4,
        searchObjects: [],
        menuArgs: this.menuArgs
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.searchData = [...this.searchData, ...res.data.rows]
      this.tablePage.total = res.data.totals
      if (this.searchData.length === this.tablePage.total) {
        this.$refs.PageSearchDataListRef.isLoadAll = true
      }
      this.$refs.PageSearchDataListRef.isLoading = false
    },
    toDetail(item) {
      this.$router.push({
        path: '/AppSporadicDetail',
        query: {
          id: item.id,
          menuArgs: this.menuArgs
        }
      })
    },
    // 加载更多
    loadNextPageData() {
      this.tablePage.currentPage++
      this.list()
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

.app_menu_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    background-color: #fafafa;
  }
}
</style>
